import {
  Dialog,
  Button,
  DialogTitle,
  IconButton,
  DialogContent,
  Typography,
  DialogActions,
  Stack,
  Grid,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { changeMode, FleetModeType } from "Redux/fleetSlice";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useDrivers from "Hooks/useDrivers";
import useCars from "Hooks/useCars";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function FleetDialoig() {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const { mode } = useAppSelector((state) => state.fleet);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    dispatch(changeMode(null));
  };

  const { isLoading: driversIsLoading, data: driversData } = useDrivers();
  const { isLoading: carswIsLoading, data: carsData } = useCars();
  // console.log(driversData, "vsdfvbs2");

  // const carsData: any = [{ tittle: "ماشین یک" }, { tittle: "ماشین دو" }, { tittle: "ماشین سه" }];
  // const driversData: any = [{ tittle: "راننده یک" }, { tittle: "راننده دو" }, { tittle: "راننده سه" }];

  const renderCars = () => {
    if (carswIsLoading) {
      return <CircularProgress color="secondary" size={30} />;
    }
    if (carsData && carsData?.length > 0) {
      return (
        <>
          {carsData?.map((car: any) => {
            return (
              <Stack direction="row">
                <Button
                  sx={{
                    border: "1px solid #aaa",
                    p: 1,
                    borderRadius: 1,
                    width: "90%",
                    marginBottom: "15px",
                    justifyContent: "flex-start",
                  }}
                >
                  <Stack sx={{ width: "100%" }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      {car.plaque}
                    </Grid>
                  </Stack>
                </Button>
                <Checkbox
                  inputProps={{ "aria-label": "Checkbox demo" }}
                  sx={{
                    "&:hover": { bgcolor: "transparent" },
                  }}
                />
              </Stack>
            );
          })}
        </>
      );
    }
    return <Typography align="center">راننده ای برای نمایش وجود ندارد</Typography>;
  };

  const renderDrivers = () => {
    if (driversIsLoading) {
      return <CircularProgress color="secondary" size={30} />;
    }
    if (driversData && driversData?.length) {
      return (
        <>
          {driversData?.map((driver: any) => {
            return (
              <Stack direction="row">
                <Button
                  sx={{
                    border: "1px solid #aaa",
                    p: 1,
                    borderRadius: 1,
                    width: "90%",
                    marginBottom: "15px",
                    justifyContent: "flex-start",
                  }}
                >
                  <Stack sx={{ width: "100%" }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      {driver.fname} {driver.lname}
                    </Grid>
                  </Stack>
                </Button>
                <Checkbox
                  inputProps={{ "aria-label": "Checkbox demo" }}
                  sx={{
                    "&:hover": { bgcolor: "transparent" },
                  }}
                />
              </Stack>
            );
          })}
        </>
      );
    }
    return <Typography align="center">راننده ای برای نمایش وجود ندارد</Typography>;
  };

  return (
    <>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={mode === "cars"}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modal title
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ margin: "auto" }}>
          {renderCars()}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={mode === "drivers"}>
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modal title
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers sx={{ margin: "auto" }}>
          {renderDrivers()}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}
